<template>
	<slot/>

	<lazy-app-footer v-if="!$device.isNative" :items="footerItems" class="relative bg-white pt-48"/>
</template>
<script setup lang="ts">
const {footerItems} = useAppFooter();
</script>
